const toastManager = () => ({
    toastStack: [],
    visible: [],
    timeouts: {},
    createToast(title, message, type = 'error') {
        const identifier = Date.now()

        const toastObject = {
            type,
            title,
            message,
        }

        // Check if we already have an identical toast visible. If so, don't bother showing the error and reset it's visiblity timer.
        const shouldShow = this.visible.every((toastItem) => {
            if (JSON.stringify({ type: toastItem.type, title: toastItem.title, message: toastItem.message }) === JSON.stringify(toastObject)) {
                clearTimeout(this.timeouts[toastItem.id])
                delete this.timeouts[toastItem.id]
                this.addTimeout(toastItem.id)

                return false
            }

            return true
        })

        if (shouldShow) {
            toastObject.id = identifier
            this.toastStack.push(toastObject)
            this.fire(identifier)
        }
    },
    fire(id) {
        this.visible.push(this.toastStack.find((toast) => toast.id === id))
        this.addTimeout(id)
    },
    removeToast(id) {
        const locatedToast = this.visible.find((toast) => toast.id === id)
        const index = this.visible.indexOf(locatedToast)
        this.visible.splice(index, 1)
    },
    addTimeout(id) {
        this.timeouts[id] = (setTimeout(() => {
            this.removeToast(id)
        }, 5000 * this.visible.length))
    },
})
document.addEventListener('alpine:init', () => {
    window.Alpine.data('toastManager', toastManager)
})
